import {Suspense} from 'react';
import {hydrateRoot} from 'react-dom/client';

import {componentItems} from 'app/componentItems';
import {ErrorBoundary} from 'app/core/errorHandler/errorBoundary';
import {appEvents} from 'app/utils/appEvents';
import {type GemSettings} from 'app/utils/config/interface';
import {findAndInitComponents} from 'app/utils/initialize/findAndInitComponents';
import {type ComponentMountDataTransporter, type FindAndInitComponentsParams} from 'app/utils/initialize/interface';

import {ComponentContextWrapper} from './components/componentContextWrapper';

export function hydrateComponents(gemSettings: GemSettings, lazyLoadPage: boolean) {
    findAndInitComponents({
        gemSettings,
        lazyLoadPage,
        callback: getCallback(gemSettings),
        context: document.body,
        components: componentItems,
        selector: '.gem-module-not-initialized[data-rendered-remotely]',
    });
}

export function hydrateWebComponents(gemSettings: GemSettings) {
    // Unmounting of Web Component after hydration is not implemented.
    // Not sure if it's needed.
    const handleHydrateWebComponentMount = (event: Event) => {
        const customEvent = event as CustomEvent<ComponentMountDataTransporter>;
        getCallback(gemSettings)(customEvent.detail);
    };

    document.addEventListener(appEvents.hydrateWebComponentMount, handleHydrateWebComponentMount);
}

function getCallback(gemSettings: GemSettings): FindAndInitComponentsParams['callback'] {
    return (value) => {
        return hydrateRoot(
            value.element,
            <ErrorBoundary msg="" showOriginalErrorMsg={true}>
                <Suspense>
                    <ComponentContextWrapper gemSettings={gemSettings}>
                        <value.ReactLazyComponent config={value.config} element={value.element} />
                    </ComponentContextWrapper>
                </Suspense>
            </ErrorBoundary>,
        );
    };
}
